import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AuthenticatedRoute from "./AuthenticatedRoute";
import asyncComponent from "./AsyncComponent";
import withTracker from "../withTracker";

const Home = asyncComponent(() => import("./Home/Home"));
const Datasets = asyncComponent(() => import("./App/Datasets/Datasets"));
const Contrasts = asyncComponent(() => import("./App/Contrasts/Contrasts"));
const Sources = asyncComponent(() => import("./App/Sources/Sources"));
const Analyze = asyncComponent(() => import("./App/Analyze/Analyze"));
const Search = asyncComponent(() => import("./App/Search/Search"));
const Navbar = asyncComponent(() => import("../Navbar/Navbar"));
const Footer = asyncComponent(() => import("./Footer"));

// details docs
const DetailsPrep = asyncComponent(() => import("./Docs/DetailsPrep"));
const DetailsAnal = asyncComponent(() => import("./Docs/DetailsAnal"));
const DetailsSearch = asyncComponent(() => import("./Docs/DetailsSearch"));

// evaluation docs
const EvalAnal = asyncComponent(() => import("./Docs/EvalAnal/EvalAnal"));
const EvalSearch = asyncComponent(() => import("./Docs/EvalSearch/EvalSearch"));

const Routes = ({ childProps }) => {
  return (
    <div>
      <Route path="/" component={Navbar} />
      <Switch>
        <Route exact path="/" component={withTracker(Home)} />

        {/* app sections */}
        <AuthenticatedRoute
          path="/app/datasets"
          component={withTracker(Datasets)}
        />
        <AuthenticatedRoute
          path="/app/contrasts"
          component={withTracker(Contrasts)}
        />
        <AuthenticatedRoute
          path="/app/sources"
          component={withTracker(Sources)}
        />
        <AuthenticatedRoute
          path="/app/analyze"
          component={withTracker(Analyze)}
        />
        <AuthenticatedRoute
          path="/app/search"
          component={withTracker(Search)}
        />

        {/* details docs */}
        <Route
          path="/docs/preprocessing"
          component={withTracker(DetailsPrep)}
        />
        <Route
          path="/docs/analysis-details"
          component={withTracker(DetailsAnal)}
        />
        <Route
          path="/docs/search-details"
          component={withTracker(DetailsSearch)}
        />

        {/* evaluation docs */}
        <Route
          path="/docs/analysis-evaluation"
          component={withTracker(EvalAnal)}
        />
        <Route
          path="/docs/search-evaluation"
          component={withTracker(EvalSearch)}
        />

        {/* not-found redirect */}
        <Route path="*" render={() => <Redirect to="/" />} />
      </Switch>
      <Route path="/" component={Footer} />
    </div>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes/Routes.js